import { type RefObject, useEffect } from 'react'

type KeyboardShortcutOptions = {
  searchInputRef: RefObject<HTMLInputElement>
  enabled?: boolean
}

export const useKeyboardShortcuts = ({ searchInputRef, enabled = true }: KeyboardShortcutOptions) => {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === '/')) {
        e.preventDefault()
        searchInputRef.current?.focus()
      } else if (e.key === 'Escape') {
        searchInputRef.current?.blur()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [searchInputRef, enabled])
}
